var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXCloseWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M11.195 9.5l7.68-7.68a.423.423 0 0 0 0-.6L17.781.124a.422.422 0 0 0-.3-.124.42.42 0 0 0-.3.124L9.5 7.806 1.818.124a.436.436 0 0 0-.6 0L.126 1.22a.423.423 0 0 0 0 .6l7.68 7.68-7.68 7.68a.423.423 0 0 0 0 .6l1.095 1.098a.431.431 0 0 0 .599 0L9.5 11.194l7.68 7.684a.429.429 0 0 0 .601 0l1.095-1.098a.425.425 0 0 0 0-.6L11.195 9.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXCloseWhiteIcon);
export default __webpack_public_path__ + "static/media/x-close-white-icon.79633bd33346e2c9ef7ded51851d5ccc.svg";
export { ForwardRef as ReactComponent };